import { call, takeLatest } from "redux-saga/effects";
import * as userApi from "../apis/userApi";
import { ADD_USER, UPLOAD_CSV_FILE, UPLOAD_USERS, USER_DELETE, USER_EDIT, USER_LIST, USER_STATUS, USER_VIEW } from "../actions/types";

export function* addUserWorker(action) {
    try {
        const res = yield call(userApi.addUserApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* userListWorker(action) {
    try {
        const res = yield call(userApi.userListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* userEditWorker(action) {
    try {
        const res = yield call(userApi.userEditApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* userDeleteWorker(action) {
    try {
        const res = yield call(userApi.userDeleteApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* userViewWorker(action) {
    try {
        const res = yield call(userApi.userViewApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* userStatusWorker(action) {
    try {
        const res = yield call(userApi.userstatusApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* uploadUsersWorker(action) {
    try {
        const res = yield call(userApi.uploadUsersApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* uploadCSVFileWorker(action) {
    try {
        const file = new FormData();
        file.append("file", action.file);
        const res = yield call(userApi.uploadCVSFileApi, file);

        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

/* Watcher Function*/

export function* addUserWatcher() {
    yield takeLatest(ADD_USER, addUserWorker);
}

export function* userListWatcher() {
    yield takeLatest(USER_LIST, userListWorker);
}

export function* userEditWatcher() {
    yield takeLatest(USER_EDIT, userEditWorker);
}

export function* userDeleteWatcher() {
    yield takeLatest(USER_DELETE, userDeleteWorker);
}

export function* userViewWatcher() {
    yield takeLatest(USER_VIEW, userViewWorker);
}

export function* userStatusWatcher() {
    yield takeLatest(USER_STATUS, userStatusWorker);
}

export function* uploadUsersWatcher() {
    yield takeLatest(UPLOAD_USERS, uploadUsersWorker);
}

export function* uploadCSVFileWatcher() {
    yield takeLatest(UPLOAD_CSV_FILE, uploadCSVFileWorker);
}